import { reactive, ref } from 'vue'
import { defineStore } from 'pinia'
import { useApi } from '../composables/api'
import type { TakedownNoticeDto } from '@roadfootage/api-client'

const initForm = (): TakedownNoticeDto => ({
  requestorFullName: null,
  requestorOrganisationName: null,
  requestorTitleOrPosition: null,
  requestorMailingAddress: null,
  requestorPhoneNumber: null,
  requestorEmailAddress: null,
  infringingContentUrl: null,
  originalContentUrl: null,
  copyrightOwnerFullName: null,
  copyrightOwnerPhoneNumber: null,
  copyrightOwnerEmailAddress: null
})

export const useTakedownNoticeStore = defineStore('takedownNotice', () => {
  const { takedownNoticesApi } = useApi()

  const isSaving = ref(false)
  const takedownNoticeForm: TakedownNoticeDto = reactive(initForm())

  function $reset() {
    Object.assign(takedownNoticeForm, initForm())
  }

  async function createTakedownNotice(turnstileToken: string) {
    isSaving.value = true
    try {
      await takedownNoticesApi.takedownNoticesSubmitTakedownNotice({
        takedownNoticeDto: takedownNoticeForm,
        turnstileToken
      })
    } catch (e) {
      isSaving.value = false
      throw e
    } finally {
      isSaving.value = false
    }
    $reset()
  }

  return {
    $reset,
    takedownNoticeForm,
    createTakedownNotice,
    isSaving
  }
})
